import React from "react";

import 'react-slideshow-image/dist/styles.css';


const Week13 = (props) => {
    return (
        <div className="HP-module">
            <div className="HP-subtitle">Week 13: Machine Week</div>
            <div className="HP-body">
                This week was machine week! We worked together a section to build the Gershenforcer, a automated nerf turret that uses image processing to 
                target late students and unleash nerf fury upon them. On the project I worked on the flywheel team. We were responsible for the initial chamber,
                 the floor of the firing mechanism, as well as the mechanism to actually launch the dart. We worked as a group (myself, Masarah, Sam, and Mauricio) 
                during the project to assemble the housing out of laser cut acrylic and 6-32 screws, mount a 20x20 aluminum extrusion chamber, design and printed 
                housings for the DC brushed motors, designed and printed adapters from the motor shaft to the flywheel center, and assembled the device until 
                darts could be shot out at any unsuspecting students. <br /><br />
                This was a very fun project and I really enjoyed working on something fundementally mechanincal, it was a breath of fresh air from my 
                software-heavy background. I also really liked working with other people in my section, as they are all great and we helped and taught each other 
                a lot. Inside of my group, I personally designed the motor housings and we assembled the pieces and designed/assembled the housing together.
            </div>
        </div>
    )
}

export default Week13;